import { ExternalLink } from "lucide-react";
import { FOUNDATION_URL, FOUNDATION_DOMAIN } from "@/data/content";

export const FoundationLink = ({ children, className = "", testId = "foundation-site-link", icon = true }) => (
  <a
    href={FOUNDATION_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 ${className}`}
  >
    {children || FOUNDATION_DOMAIN}
    {icon && <ExternalLink size={13} className="shrink-0" />}
  </a>
);
